import type { TransferData } from '../../constants'
import { normalizeDescriptionText, parseDescriptionFromHtml } from '../../utils/parser'

function extractInfoValue (info: string, regex: RegExp): string {
  return info.match(regex)?.[1]?.trim() || ''
}

function parseDescription (): string {
  const report = document.querySelector('#link-report')
  const fullSpan = report?.querySelector('.all .intro') || report?.querySelector('.intro')
  const rawDesc = fullSpan ? fullSpan.innerHTML : (report?.innerHTML || '')

  const normalizedHtml = rawDesc
    .replace(/<a[^>]*>(\(展开全部\)\s*)?<\/a>/g, '')

  return normalizeDescriptionText(parseDescriptionFromHtml(normalizedHtml))
}

function parseRating (): string {
  const nRating = (document.querySelector('#n_rating') as HTMLInputElement | null)?.value
  if (nRating) return parseFloat(nRating).toFixed(1)

  const starClass = document.querySelector<HTMLElement>('#interest_sect_level .ll')?.className
  if (!starClass) return ''

  const match = starClass.match(/bigstar(\d+)/)
  if (!match) return ''

  return (parseInt(match[1], 10) / 10).toFixed(1)
}

function parseShortReview (): string {
  const reviewSpans = Array.from(document.querySelectorAll<HTMLElement>('#interest_sect_level .j.a_stars > span:not([class])'))
  if (reviewSpans.length > 0) {
    return reviewSpans[reviewSpans.length - 1].innerText.trim()
  }

  const fallbacks = ['#my_short_comment', '.my-comment .comment-content', 'textarea#comment']
  for (const selector of fallbacks) {
    const el = document.querySelector<HTMLElement | HTMLTextAreaElement>(selector)
    if (!el) continue

    const val = (el instanceof HTMLTextAreaElement ? el.value : el.innerText).trim()
    if (val) return val
  }

  return ''
}

export function parseDoubanPage (): TransferData {
  const info = document.querySelector<HTMLElement>('#info')?.innerText || ''
  const title = document.querySelector<HTMLElement>('h1 span')?.innerText || 'book'
  const coverUrl = document.querySelector<HTMLAnchorElement>('#mainpic a.nbg')?.href || ''

  return {
    title,
    originalTitle: extractInfoValue(info, /原作名:?\s*(.+)/),
    author: extractInfoValue(info, /作者:?\s*(.+)/),
    language: extractInfoValue(info, /语言:?\s*(.+)/),
    publisher: extractInfoValue(info, /出版社:?\s*(.+)/),
    isbn: extractInfoValue(info, /ISBN:?\s*(\d+)/),
    pages: extractInfoValue(info, /页数:?\s*(\d+)/),
    pubDate: extractInfoValue(info, /出版年:?\s*(.+)/),
    format: info.includes('精装') ? 'hardcover' : (info.includes('平装') ? 'paperback' : ''),
    desc: parseDescription(),
    rating: parseRating(),
    review: parseShortReview(),
    coverUrl
  }
}
